import createRequest from '@/utils/request/main'

const request = createRequest(`${process.env.VUE_APP_BASE_API || ''}/scpcm`) // 生产环境

/**
 * 模块接口
 * @param {Object} data
 */

//  获取模块列表
export function moduleList(date) {
  return request.post('module/findList', date)
}

//  新增模块
export function moduleSave(date) {
  return request.post('module/save', date)
}

//  删除模块
export function moduleDelete(date) {
  return request.post('module/delete', date)
}

//  查询表单列表
export function moduleFormList(date) {
  return request.post('moduleForm/findList', date)
}

//  保存表单
export function moduleFormSave(date) {
  return request.post('moduleForm/save', date)
}

//  查询表单
export function moduleDetail(date) {
  return request.post('moduleBusiness/getDetail', date)
}

//  查询表单header
export function findSelectMenu(date) {
  return request.post('moduleFormConfig/findSelectMenu', date)
}

//  查询表单header设置
export function findAllMenu(date) {
  return request.post('moduleFormConfig/findAllMenu', date)
}

//  保存表单header配置
export function save(date) {
  return request.post('moduleFormConfig/save', date)
}

//  保存表单数据
export function moduleBusinessSave(date) {
  return request.post('moduleBusiness/save', date)
}

//  查询表单查询条件
export function findSearchData(date) {
  return request.post('moduleFormConfig/findSearchData', date)
}

// 查询表单数据
export function moduleBusinessList(page, pageSize, date) {
  return request.post('moduleBusiness/findPageList?page=' + page + '&pageSize=' + pageSize, date)
}

//  删除表单数据
export function moduleBusinessDel(date) {
  return request.post('moduleBusiness/delete', date)
}
